import { jsx as _jsx } from "react/jsx-runtime";
import { classNameParserCore } from "../../coreFunctions/classNameParserCore/classNameParserCore";
import "./vertical-separator-core.scss";
/**
 * A simple vertical divider component.
 * Uses a thin line (w-px) with a subtle gray color.
 */
export const VerticalSeparatorCore = ({ className = "", }) => {
    return (_jsx("div", { className: classNameParserCore("vertical-separator-core-container", className) }));
};
